<template>
  <CommonFramework :name="'找回密码'">
    <pop-panel :name="'邮箱验证'">
      <a-form
        :form="form"
        @submit="save"
        class="pop-common-form"
        :style="{width: '820px', margin: '0 auto'}">
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.email.validateStatus"
          :help="form.email.help"
          hasFeedback>
          <template slot="label">
            <span class="required">邮箱号</span>
          </template>
          <Input
              placeholder="请输入邮箱号"
              v-model="form.email.value"
              @change="validateHandler('email', $event)"/>
          <span class="iconTip" v-show="!form.email.value && !form.email.validateStatus"><img src="../../../assets/images/icon-tip.jpg"><span>请输入账号绑定邮箱</span></span>        
        </a-form-item>
        <sendemail 
          :email="form.email.value"
          :value.sync="form.codeEmail.value" 
          :validateStatus="form.codeEmail.validateStatus"
          :help="form.codeEmail.help"
          :isSendCode.sync = isSendCode
          serviceType="PWD"
          @resetCode="getNewCode"
          @checkCode="checkCode"
          >
        </sendemail>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.newPassword.validateStatus"
          :help="form.newPassword.help"
          hasFeedback>
          <template slot="label">
            <span class="required">新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请输入密码"
            v-model="form.newPassword.value"
            @change="validateHandler('newPassword', $event)"
            maxLength="20"
          />
          <span class="iconTip" v-show="!form.newPassword.value && !form.newPassword.validateStatus"><img src="../../../assets/images/icon-tip.jpg"><span>{{this.pwdValidMsg}}</span></span>        
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.confirmNewPassword.validateStatus"
          :help="form.confirmNewPassword.help"
          hasFeedback>
          <template slot="label">
            <span class="required">确认新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请再次输入密码"
            v-model="form.confirmNewPassword.value"
            @change="validateHandler('confirmNewPassword', $event)"
            maxLength="20"
          />
          <span class="iconTip" v-show="!form.confirmNewPassword.value && !form.confirmNewPassword.validateStatus"><img src="../../../assets/images/icon-tip.jpg"><span>{{this.pwdValidMsg}}</span></span>        
        </a-form-item>
        <a-form-item>
          <template>
            <p class="tip">收不到邮箱检验码？请核实邮箱是否是绑定的邮箱</p>
            <span class="tip">选择其他方式认证：</span> 
            <a @click="jumpTolink('leyouauth-forget-mobile')" class="line">手机验证</a>
          </template>
        </a-form-item>
        <a-form-item
          class="form-item"
          label=" "
          v-bind="formItemLayout">
          <Button class="op-btn" type="primary" @click="save" :disabled="isDisabled">保存</Button>
          <Button class="op-btn" @click="jumpTolink('leyouforget')">返回</Button>
        </a-form-item>
      </a-form>
    </pop-panel>
  </CommonFramework>
  </template>
  
  <script>
   import CommonFramework from "../../../shared/components/lyCommonFramework/index";
    import { Input, Button } from 'ant-design-vue'
    import PopPanel from "@components/popPanel/index";
    import form from "../../../shared/utils/form";
    import sendemail from '@components/sendsms/sendemail/index';
    import appConst from '@utils/constant';
    import base64 from 'js-base64';
    import api from '@utils/api';
    import {$http, http, util} from '@utils';
    import queryString from 'query-string';
    import CONSTANT from '@utils/constant'
  
    export default {
      name: "forget-email",
      components: {CommonFramework, PopPanel, Input, Button, sendemail},
      mixins: [ form ],
      data () {
        return {
          pwdValidMsg: this.$store.state.securityConfig.pwdValidMsg,
          form: {
            email: {
              value: '',
              validateStatus: '',
              help: ''
            },
            codeEmail: {
              value: '',
              validateStatus: '',
              help: ''
            },
            newPassword: {
              value: '',
              validateStatus: '',
              help: ''
            },
            confirmNewPassword: {
              value: '',
              validateStatus: '',
              help: ''
            },
          },
          isSendCode: false,
        }
      },
      mounted() {
        util.$tracker(157, '288921', 10000);
      },
      methods: {
        jumpTolink (name) {
          this.$router.push({
            name
          })
        },
        async getNewCode() {
          // this.validateFields(['email'] 状态校验
          if (await this.validateFields(['email'])) {
            this.isSendCode = true
          } else {
            this.isSendCode = false
          }
        },
        checkCode() {
          this.validateFields(['codeEmail'])
        },
        // 忘记密码-邮箱找回
        async forgetPwdByEmail(email, pwd, confirmNewPassword, code) {
          const serviceCode = `${appConst.APPSERVICECODE_PWD}`;
          const _api = `${api.mainHost}/portal-api/account/forgetPwdByEmail.do`
          // const _api = `http://172.21.14.61/portal-api/account/forgetPwdByEmail.do`
          const param = JSON.stringify({
            email: `${email}`,
            password: `${pwd}`,
            confirmPassword: `${confirmNewPassword}`,
            verifyCode: `${code}`,
            serviceCode
          })
          const res = await http.post(_api, queryString.stringify({param}), {
            headers: {
              'content-Type': 'application/x-www-form-urlencoded'
            }
          })
          return res   
        },
        async save () {
          if (await this.validateFields()) {
            const res = await this.forgetPwdByEmail(this.form.email.value, this.form.newPassword.value, this.form.confirmNewPassword.value, this.form.codeEmail.value)
            if (res.code * 1 === 1) {
              this.$message.success('密码找回成功');
              setTimeout(() => {
                this.jumpTolink('lylogin')
              }, 1000)
            } else {
              this.$message.error(res.msg || '系统异常');
            }
          }
  
        }
      }
    }
  </script>
  <style lang="scss" src="./index.scss" scoped></style>
  
  
  